import type { LocationQuery } from 'vue-router'

// 'utm_source', 'utm_medium', 'utm_campaign', 'utm_term', 'utm_content'
/*
    Миддлварка для рекламных акций
    Если юзер переходит по рекламной ссылке с квери параметрами
    Мы сохраняем эти параметры в куках
    И передаем в формах обратной связи c роутами '/v1/callbacks'
    (aka CalculateModal, FeedbackModal, RemainingQuestionsSection)
*/

export default defineNuxtRouteMiddleware(() => {
    const isProd = import.meta.env.PROD

    if (!isProd) return

    const route = useRoute()
    const utm = useCookie<LocationQuery>('utm', {
        maxAge: 60 * 60 * 24 * 7,
    })

    utm.value = route.query
})
